module.exports = __webpack_public_path__ + "391f8ec82eaf827442a65b4640194c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/images/login-dialog.png
// module id = 2791
// module chunks = 4